import Slideshow from '@/lib/slideshow.js';

export default function () {
	const slideshow = new Slideshow();

	slideshow.setup('.slideshow-container');
}
